import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { toast } from 'react-toastify';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import TitleFrom from '../../../../components/common/TitleFrom';
import { TransactionSummarySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportBillTransactionSummary, sortBillTransactionSummary } from '../../constants';
import { getBillTransactionSummary, getAllBillTransactionSummary } from '../../actions';
import { makeGetListBillTransactionSummary, makeGetListAllBillTransactionSummary } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import {
  getUniqueProductFamily,
  uploadMultiPartFiles,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';
import { isEndConnected } from '../../../Loader/actions';

let tableColumnsOutput = null;

class TransactionSummary extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    isExporting: false,
    listBillTransactionSummary: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listBillTransactionSummary: props.listBillTransactionSummary,
      totalCount: getPageTotalCount({ ...state, items: props.listBillTransactionSummary }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetBilledTransactionSummaryReport },
    } = this.props;
    if (modeGetBilledTransactionSummaryReport) {
      this.doGetListBillTransactionSummary();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListBillTransactionSummary();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListBillTransactionSummary());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListBillTransactionSummary());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListBillTransactionSummary();
    });
  };

  doGetListBillTransactionSummary = () => {
    if (this.state.isExporting) return;
    const { filter, page, size, sorted } = this.state;
    const { getBillTransactionSummary } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortBillTransactionSummary[sorted.sortCol]
          ? sortBillTransactionSummary[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getBillTransactionSummary(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistBillTransactionSummary = cb => {
    const { filter, sorted } = this.state;
    if (!filter.startDate || !filter.endDate) {
      if (cb) cb({ success: false });
      return;
    }
    const { getAllBillTransactionSummary } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortBillTransactionSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllBillTransactionSummary(payload, ({ success, data }) => {
      if (cb) cb({ success, data });
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    if (this.state.isExporting) return;
    this.setState({ isExporting: true });
    const isActivePdfSnapshot = this.state.isActivePdf;
    const columnsTableSnapshot = tableColumnsOutput ? [...tableColumnsOutput] : [];
    const { t } = this.props;
    const fileName = `${t('reportPage:sidebar.transactionSummary')
      .toLocaleLowerCase()
      .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`;
    this.doGetAlllistBillTransactionSummary(({ success, data }) => {
      if (!success || !data || !data.length) {
        toast.error(t('message.exportFailed'));
        this.props.isEndConnected();
        this.setState({ isExporting: false });
        return;
      }
      try {
        if (isActivePdfSnapshot) {
          convertJson2Pdf({
            data,
            t,
            title: t('reportPage:sidebar.transactionSummary').toLocaleUpperCase(),
            fileName,
            columnsTable: columnsTableSnapshot,
            fontSize: 3,
          });
        } else {
          const csvFile = blobToCSVFile({
            fileName: `${fileName}.csv`,
            data,
            t,
            columns: columnsTableSnapshot,
            listOptionFields: { accountType: 'accountType', status: 'invoiceStatus', serviceType: 'serviceType' },
          });
          const url = URL.createObjectURL(csvFile);
          const a = document.createElement('a');
          a.href = url;
          a.download = csvFile.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(url), 1500);
        }
        // Hide loader after browser has queued the download
        setTimeout(() => {
          this.props.isEndConnected();
          this.setState({ isExporting: false });
        }, 1500);
      } catch (e) {
        toast.error(t('message.exportFailed'));
        this.props.isEndConnected();
        this.setState({ isExporting: false });
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    if (this.state.isExporting) return;
    this.setState({ isExporting: true });
    const { t } = this.props;
    this.doGetAlllistBillTransactionSummary(({ success, data }) => {
      if (!success || !data || !data.length) {
        toast.error(t('message.emailSendFailed'));
        this.props.isEndConnected();
        this.setState({ isExporting: false });
        return;
      }
      try {
        const { uploadMultiPartFiles } = this.props;
        const { emails, isActivePdf } = this.state;

        const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
          {
            emailAddress: emails.join(', '),
            type: 'GET_BILLED_TRANSACTION_SUMMARY_REPORT',
            subject: subject || `Embrix Report ${t('reportPage:sidebar.transactionSummary')}`,
            emailBody,
          },
          ['type']
        )})}"}`;
        const formData = new FormData();

        if (!isActivePdf) {
          formData.append(
            'file',
            blobToCSVFile({
              fileName: `${t('reportPage:sidebar.transactionSummary')
                .toLocaleLowerCase()
                .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
              data,
              t,
              columns: tableColumnsOutput,
              listOptionFields: { accountType: 'accountType', status: 'invoiceStatus', serviceType: 'serviceType' },
            })
          );
        } else {
          const pdfFile = convertJson2Pdf({
            data,
            t,
            title: t('reportPage:sidebar.transactionSummary').toLocaleUpperCase(),
            fileName: `${t('reportPage:sidebar.transactionSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
            isFile: true,
            columnsTable: tableColumnsOutput,
            fontSize: 3,
          });
          formData.append(
            'file',
            blobToFile(
              pdfFile,
              `${t('reportPage:sidebar.transactionSummary')
                .toLocaleLowerCase()
                .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
            )
          );
        }

        formData.append('graphql', query);
        uploadMultiPartFiles(
          formData,
          res => {
            this.setState({ isExporting: false });
            if (res && res.success) {
              toast.success(t('message.emailSendSuccess'));
              this.setState({ emails: [] });
            } else {
              toast.error(t('message.emailSendFailed'));
            }
          },
          true
        );
      } catch (e) {
        toast.error(t('message.emailSendFailed'));
        this.props.isEndConnected();
        this.setState({ isExporting: false });
      }
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('TRANSACTION_SUMMARY_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportBillTransactionSummary,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listBillTransactionSummary,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
      isExporting,
      filter,
    } = this.state;
    const canExport = !!(filter.startDate && filter.endDate);
    const {
      t,
      getUniqueProductFamily,
      permissions: { modeGetBilledTransactionSummaryReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetBilledTransactionSummaryReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.transactionSummary') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.transactionSummary')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <TransactionSummarySearchForm
                  getUniqueProductFamily={getUniqueProductFamily}
                  onSubmit={this.onHandleSubmitSearch}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} disabled={!canExport || isExporting} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.transactionSummary').toLocaleUpperCase()}
                        multiDataSet={this.state.exportSheetData || []}
                        fileName={`${t('reportPage:sidebar.transactionSummary')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      canSend={canExport && !isExporting}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listBillTransactionSummary && listBillTransactionSummary.length ? listBillTransactionSummary : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

TransactionSummary.propTypes = {
  getBillTransactionSummary: PropTypes.func,
  getAllBillTransactionSummary: PropTypes.func,
  listAllBillTransactionSummary: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

TransactionSummary.defaultProps = {
  getBillTransactionSummary: () => {},
  getAllBillTransactionSummary: () => {},
  listAllBillTransactionSummary: [],
};

const mapStateToProps = createStructuredSelector({
  listBillTransactionSummary: makeGetListBillTransactionSummary() || [],
  listAllBillTransactionSummary: makeGetListAllBillTransactionSummary() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getBillTransactionSummary,
    getAllBillTransactionSummary,
    getUniqueProductFamily,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    isEndConnected,
  })(TransactionSummary)
);
